export default __webpack_public_path__ + "static/media/hire.a5e97e3d.png";